<template>
  <div class="single-precopyright-item">
    <div class="image-upload">
      <div
        class="overlay-button"
        v-if="!partnerImg && !getImage"
        @click="$refs.imgInput.click()"
      >
        +
      </div>
      <img :src="partnerImg" v-show="partnerImg" alt="" ref="selectedImage" />
      <img
        :src="getImage"
        v-show="!partnerImg && getImage"
        ref="currentImg"
        @click="$refs.imgInput.click()"
      />
      <input
        :maxlength="255"
        ref="imgInput"
        type="file"
        style="display: none;"
        @change="addImage($event)"
      />
    </div>
    <div class="size">
      <a-input
        :maxLength="255"
        placeholder="Width"
        class="terms-input"
        id="terms-input"
        style="width: 70px;"
        :value="naturalWidth"
        @input="emitWidth($event.target.value)"
        disabled
      />
    </div>
    <div class="size">
      <a-input
        :maxLength="255"
        placeholder="Height"
        class="terms-input"
        id="terms-input"
        style="width: 70px;"
        :value="naturalHeight"
        @input="emitHeight($event.target.value)"
        disabled
      />
    </div>
    <div class="link">
      <a-input
        :addon-before="FOOTER_URL_PREFIX"
        :maxLength="255"
        default-value="domain.com"
        class="link-input"
        :value="strippedUrl"
        @input="emitDomain(FOOTER_URL_PREFIX + $event.target.value)"
      />
    </div>
    <div class="btn-wrap">
      <a-button type="primary" class="btn-upload" @click="uploadImage">
        <span class="material-icons">upload</span>
        Upload
      </a-button>
      <a-button
        type="primary"
        class="btn-remove"
        @click="deleteItem"
        v-if="controls"
      >
        <span class="material-icons">delete</span>
        Remove
      </a-button>
      <a-button
        type="primary"
        class="btn-updown"
        @click="pushUpItem"
        v-if="controls"
      >
        <span class="material-icons">expand_less</span>
      </a-button>
      <a-button
        type="primary"
        class="btn-updown"
        @click="pushDownItem"
        v-if="controls"
      >
        <span class="material-icons">expand_more</span>
      </a-button>
      <a-button
        type="primary"
        class="btn-updown"
        @click="addNewItem"
        v-if="isLast"
      >
        <i class="material-icons">add</i>
      </a-button>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';
export default {
  props: {
    index: {
      type: Number,
    },
    isLast: {
      type: Boolean,
    },
    el: {
      type: Object,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      partnerImg: null,
      formData: {},
      selectedImg: null,
      naturalWidth: 0,
      naturalHeight: 0,
      getImage: null,
    }
  },
  computed: {
    ...mapState(['FOOTER_URL_PREFIX']),
    strippedUrl () {
      return this.el.domain.slice(this.FOOTER_URL_PREFIX.length);
    },
  },
  watch: {
    el: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    init () {
      this.formatData();

      this.$nextTick(() => {
        setTimeout(() => {
          this.naturalWidth = this.$refs.currentImg.naturalWidth
          this.naturalHeight = this.$refs.currentImg.naturalHeight
        }, 150)
      })
    },
    formatData() {
      if (!this.poweredByData && this.el.img) {
        this.getImage =
          process.env.VUE_APP_API_URL + '/footer/image/' + this.el.img
      }
    },
    emitHeight(newVal) {
      this.$emit('heightValue', { id: this.index, height: newVal })
    },
    emitWidth(newVal) {
      this.$emit('widthValue', { id: this.index, width: newVal })
    },
    emitDomain(newVal) {
      this.$emit("domainValue", { id: this.index, domain: newVal });
    },
    addNewItem() {
      this.$emit('addNewItem')
    },
    deleteItem() {
      this.$emit('removeItem', this.index)
    },
    pushUpItem() {
      this.$emit('pushUpItem', this.index)
    },
    pushDownItem() {
      this.$emit('pushDownItem', this.index)
    },
    addImage(e) {
      this.selectedImg = e.target.files[0]
      this.$nextTick(() => {
        setTimeout(() => {
          this.naturalWidth = this.$refs.selectedImage.naturalWidth
          this.naturalHeight = this.$refs.selectedImage.naturalHeight
        }, 100)
        this.partnerImg = URL.createObjectURL(e.target.files[0])
      })
    },
    async uploadImage() {
      this.formData = new FormData()
      this.formData.append('image', this.selectedImg)
      try {
        const res = await api.postFooterImage(this.formData)
        if (res.data.fdt_id) {
          let obj = {
            image: res.data.fdt_id,
            url: this.el.domain,
            index: this.index,
          }
          this.$emit('partnerLogoImage', obj)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.single-precopyright-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 670px;
  margin: 16px 0;
  .image-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: #ffffff;
    border: 1px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 2px;
    width: 181px;
    height: 40px;
    margin: 0 8px 0 0;
    img {
      display: block;
      height: 70%;
      margin: 0 auto;
      //   height: 30px;
      // position: absolute;
      //   top: 10%;
      //   transform: translateX(-50%);
    }
    .overlay-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f4f5f7;
      cursor: pointer;
      box-sizing: border-box;
      border-radius: 2px;
      height: 100%;
      width: 100%;
      font-size: 20px;
      color: #969da8;
    }
  }
  //utility
  input,
  .ant-input,
  .ant-input-group-addon {
    border-radius: 2px !important;
  }
  .label-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 5px 0;
    .material-icons {
      color: #b2bac7;
      font-size: 14px;
      display: inline-block;
      margin: 0 5px;
    }
  }
  //utility ends
  .terms-input {
    width: 150px;
    height: 40px;
    box-sizing: border-box;
    margin: 0 7px 0 0;
  }
  .link-input {
    height: 40px;
  }
  .btn-wrap {
    display: flex;
    align-self: flex-end;
    .btn-remove,
    .btn-upload {
      width: 100px;
      height: 40px;
      background: #d23214;
      border-radius: 2px;
      border: none;
      margin: 0 4px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      color: #ffffff;
    }
    .btn-upload {
      background: #2295d6;
    }

    .btn-updown {
      width: 40px;
      height: 40px;
      background: #f4f5f7;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      margin: 0 4px;
      .material-icons {
        color: #001529;
      }
    }
  }
}
</style>

<style>
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div:nth-child(11)
  > div.upload-partner-logos
  > div
  > div.link
  > span
  > span
  > input {
  border-radius: 2px !important;
  width: 181px !important;
  height: 40px !important;
}

body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.powered-by
  > div:nth-child(4)
  > div
  > div.link
  > span
  > span
  > input {
  height: 40px;
  border-radius: 2px;
}
</style>
